<template>
  <div
    :class="[
      $style.table__content_row,
      order.status.name === 'Закрытый' && $style.table__content_row_active
    ]"
    id="table__content_row"
    @click="goToOrderDetails(order)"
  >
    <div :style="{ flexDirection: 'column' }" :class="$style.table__content_column">
      <span>{{ order.id }}</span>
      <span style="padding-left: 5px" v-if="order.groupId"> группа:{{ order.groupId }}</span>

      <i
        v-show="order.groupId && order.length > 1"
        style="margin-left: 5px; padding: 10px; cursor: pointer"
        @click="$emit('expand')"
        >+</i
      >
    </div>
    <div :class="$style.table__content_column">
      {{ order.datetime ? moment(order.datetime).format('YYYY-MM-DD  LT') : 'Не заполнено' }}
    </div>
    <div :class="$style.table__content_column">
      {{ order && order.status ? order.status.name : 'Не заполнено' }}
    </div>
    <div :class="$style.table__content_column">
      {{
        order.teacher &&
        `${order.teacher.attributes.lastName} ${order.teacher.attributes.firstName} ${
          order.teacher.attributes.middleName ?? ''
        } (id: ${order.teacher.id})`
      }}
    </div>
    <div :class="$style.table__content_column">
      {{
        `${order.student.attributes.lastName} ${order.student.attributes.firstName} ${
          order.student.attributes.middleName ?? ''
        } (id: ${order.student.id})`
      }}
    </div>
    <div :class="$style.table__content_column">
      {{ `${order?.subject?.name || ''}` }}
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import { mapMutations } from 'vuex'

export default {
  name: 'TableRow',
  props: ['order'],
  computed: {
    moment() {
      return Moment
    }
  },
  methods: {
    ...mapMutations(['setOrderDetails']),

    goToOrderDetails(order) {
      this.setOrderDetails(order)
      this.$router.push(`/orders/${order.id}`)
    }
  }
}
</script>

<style module lang="scss">
@import '@/assets/styles/colors.scss';

.table {
  &__content {
    &_row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      //height: 2.5rem;
      border-bottom: 1px solid $table-border;
      cursor: pointer;
      transition: all 0.3s ease;
      &_active {
        background: red;
        border-right: 1px solid $table-border;
      }

      &:hover {
        background: #e7e4e4;

        opacity: 0.8;
      }
    }
    &_column {
      display: flex;
      align-items: center;
      padding: 0.7rem 1rem;
      font-size: 0.875rem;
      font-weight: 500;

      &:first-child {
        width: 9.5%;
        justify-content: center;
      }

      &:nth-child(n + 2) {
        width: 22.5%;
      }

      &:last-child {
        border: none;
      }
    }

    &_rowLine {
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }

    &_line {
      border-right: 1px solid $table-border;

      &:first-child {
        width: 7.5%;
      }

      &:nth-child(n + 2) {
        width: 18.5%;
      }

      &:last-child {
        border: none;
      }
    }
  }
}
</style>
